export function toggleSearchCalendarVisibility()
{
    if(!$('.search-calendar-wrapper').hasClass('hidden'))
    {
        $('body').removeClass('search-calendar-open');
        $('.search-calendar-wrapper').addClass('hidden');
    }
    else
    {
        $('body').addClass('search-calendar-open');
        $('.search-calendar-wrapper').removeClass('hidden');
	    if(!$('#areaSelectorBox').hasClass('hidden')){
		    $('#areaSelectorBox').addClass('hidden');
		    if(!$('#searcharea').hasClass('expandedVisible')){
			    $('#esmark-map').removeClass('hidden');
		    }
	    }
    }
}
